/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as ActionTypes from './actionTypes';

const initialState = {
  planType: [],
  rebateProgramList: [],
  rebateProgramNameValue: '',
  selectedPlanType: '',
  rebateProgramValue: '',
  errors: [],

  rebateProgramName: '',
  searchResult: [],
  manufacturerList: [],
  isLoading: false,
  manufacturerSelected: [],
  isAllManufacturersSelected: true,
  scrollDownManufacturers: true,
  quarter: '',
  quarterValue: '',
  selectedRowIndexValue: '',
  chipCshcnMaxQuarter: '',
  searchScreenVar: {
    rebateProgramValue: '',
    selectedPlanType: '',
    rebateProgrameName: '',
    quarterValue: '',
    isAllManufacturersSelected: true,
    scrollDownManufacturers: true,
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_PLAN_TYPE_DATA:
      return { ...state, planType: action.payload };
    // case ActionTypes.GET_REBATE_PROGRAM_CHIP_CSHCN_RATE_AUDIT:
    //   return { ...state, rebateProgramList: action.payload };
    case ActionTypes.SET_SELECTED_CHIP_CSHCN_RATE_AUDIT:
      return { ...state, ...action.payload };
    case ActionTypes.IS_LOADING_ADJUSTMENT_CHIP_CSHCN_RATES:
      return { ...state, isLoading: action.isLoading };
    case ActionTypes.GET_CHIP_CSHCN_RATE_AUDIT_MAX_QUARTER:
      return {
        ...state,
        chipCshcnMaxQuarter: action.chipCshcnMaxQuarter,
      };
    //Manufacturer Grid
    case ActionTypes.GET_MANUFACTURER_LIST_CHIP_CSHCN_RATES:
      return { ...state, manufacturerList: action.manufacturerList };
    case ActionTypes.REFRESH_CHIP_CSHCN_RATE_AUDIT:
      return { ...state, searchScreenVar: initialState.searchScreenVar };
    case ActionTypes.REFRESH_CHIP_CSHCN_RATE_AUDIT_DISPLAY:
      return { ...state, searchScreenVar: initialState.searchScreenVar };
    //Resutl Grid
    case ActionTypes.GET_RESULT_CHIP_CSHCN_RATE_AUDIT:
      return { ...state, searchResult: action.searchResult };

    default:
      return state;
  }
};

export default reducer;
